export default __webpack_public_path__ + "static/media/ex.5bb8df93.svg";